"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactFiles = _interopRequireDefault(require("react-files"));

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

var _MockImage = _interopRequireDefault(require("../../MockImage"));

var ShotTab = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ShotTab, _Component);

  function ShotTab() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ShotTab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ShotTab)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFilesChange", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(passedFiles) {
        var hasUpdatePermission, _this$props, addFileToQueue, updateAssets, assetIds, organisationId, newAssetIds;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                hasUpdatePermission = _this.props.hasUpdatePermission;

                if (!(!passedFiles.length || !hasUpdatePermission)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _this$props = _this.props, addFileToQueue = _this$props.addFileToQueue, updateAssets = _this$props.updateAssets, assetIds = _this$props.assetIds, organisationId = _this$props.organisationId;
                _context.next = 6;
                return Promise.all(passedFiles.map(function (file) {
                  return addFileToQueue({
                    file: file
                  }, organisationId);
                }));

              case 6:
                newAssetIds = _context.sent;

                _this._filePickerRef.removeFiles();

                updateAssets([].concat((0, _toConsumableArray2.default)(assetIds), (0, _toConsumableArray2.default)(newAssetIds.filter(function (assetId) {
                  return assetId !== '';
                }))));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setFilePickerRef", function (ref) {
      if (_this._filePickerRef || !ref) {
        return;
      }

      _this._filePickerRef = ref;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderAssets", function (asset, assetId) {
      if (asset) {
        return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_MockImage.default, (0, _extends2.default)({
          asset: asset,
          assetId: assetId
        }, asset.assetFiles.ORIGINAL)), _react.default.createElement("p", {
          className: "storyboard-tab__name"
        }, asset && asset.filename));
      }

      if (asset === null) {
        return _react.default.createElement("div", {
          className: "storyboard-tab__preview"
        }, _react.default.createElement(_commonReact.AssetPreview, {
          height: 150,
          width: 260,
          asset: asset,
          hideFileTypeIcon: true
        }));
      }

      return null;
    });
    return _this;
  }

  (0, _createClass2.default)(ShotTab, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          assetIds = _this$props2.assetIds,
          hasUpdatePermission = _this$props2.hasUpdatePermission;
      return _react.default.createElement("div", {
        className: "storyboard-tab"
      }, _react.default.createElement("h3", null, "My Shot Collection"), _react.default.createElement("p", null, "Select assets"), _react.default.createElement("div", {
        className: "storyboard-tab__list"
      }, assetIds && assetIds.map(function (assetId) {
        return _react.default.createElement(_commonReact.AssetSelector, {
          key: assetId,
          assetId: assetId
        }, function (asset) {
          return _this2.renderAssets(asset, assetId);
        });
      })), _react.default.createElement(_reactFiles.default, {
        onChange: this.handleFilesChange,
        accepts: ['image/*'],
        minFileSize: 1,
        clickable: hasUpdatePermission,
        ref: this.setFilePickerRef,
        multiple: true
      }, _react.default.createElement(_uiKit.Button, {
        disabled: !hasUpdatePermission,
        small: true
      }, "Browse Files")));
    }
  }]);
  return ShotTab;
}(_react.Component);

exports.default = ShotTab;